export default __webpack_public_path__ + "static/media/vip-weekly-bonus.7ea9e56d.svg";